export const RULES_FOR_OBTAINING_PERMISSIONS_ROUTE = 'zasady-zdobywania-uprawnien';
